import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { loadCountries } from 'store/modules/countries/actions';
import { useCountriesAsArray } from 'store/modules/countries/hooks';
import { loadStates } from 'store/modules/states/actions';
import { useStatesAsArray } from 'store/modules/states/hooks';

function CountriesStatesRequest(): null {
  const dispatch = useDispatch();
  const countries = useCountriesAsArray();
  const states = useStatesAsArray();

  useEffect(() => {
    if (countries.length < 2) {
      dispatch(loadCountries());
    }
    if (!states.length) {
      dispatch(loadStates());
    }
  }, [dispatch, countries, states]);

  return null;
}

export default CountriesStatesRequest;
